import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { TransparentButton, TrashButton } from '@checkmarx/cx-ui';
import DeleteDialog from '../../portal/dialogs/deleteDialog';
import LdapServerAdditionalDetails from '../ldapServerAdditionalDetails';
import LdapServerMainDetails from '../ldapServerMainDetails';
import LdapEditFormsContainer from '../ldapEditFormsContainer';
import { LdapEditMode } from '../../../services/enums/ldap';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import ErrorDialog from '../../portal/dialogs/errorDialog';

@inject('translationsStore', 'rootLdapStore', 'teamsStore') @observer
export default class LdapServer extends Component {

    rootLdapStore = this.props.rootLdapStore;
    currentLdapStore = this.rootLdapStore.ldapStore;
    ldapValidator = this.props.rootLdapStore.ldapValidator;
    errorDialogMessage;

    state = {
        openDeleteDialog: false,
        edit: false,
        serverId: 0,
        openErrorDialog: false,
        getLDAPServerProgress: false
    };

    openDeleteServerDialog = () => {

        this.setState({
            openDeleteDialog: true
        });
    }

    deleteServer = () => {

        const serverId = this.props.server.id;

        this.currentLdapStore.deleteLDAPServer(serverId)
            .then(() => {

                var level = ToastrLevelsEnum.SUCCESS;
                var message = this.props.translationsStore.translate('LDAP_SERVER_DELETED_SUCCESS_MESSAGE');
                ToastrService.triggerToastr({level, message});
                this.rootLdapStore.getLDAPServers();
            })
            .catch(() => {
                this.errorDialogMessage = this.currentLdapStore.deleteLDAPServerErrorMessage;
                this.openErrorDialog();
            })
            .finally(() => {
                this.closeDeleteDialog();
            });

    }

    closeDeleteDialog = () => {

        this.setState({
            openDeleteDialog: false
        });
    }

    openEditForm = () => {

        const serverId = this.props.server.id;

        this.setState({
            serverId: serverId
        });

        this.rootLdapStore.addStore(serverId);
        this.rootLdapStore.addValidatorStore(serverId);

        const ldapStore = this.rootLdapStore.getStore(serverId).ldapEditStore;
        const ldapValidator = this.rootLdapStore.getValidatorStore(serverId).ldapValidator;

        this.setState({
            getLDAPServerProgress: true
        });

        ldapStore.getLDAPServer(serverId)
            .then((ldapServer) => {

                ldapStore.setActive(ldapServer.active);
                ldapStore.setDefaultMethod(ldapServer.defaultMethod);
                ldapStore.setName(ldapServer.name);
                ldapStore.setHost(ldapServer.host);
                ldapStore.setPort(ldapServer.port);
                ldapStore.setUsername(ldapServer.username);
                ldapStore.setPassword(ldapServer.password);
                ldapStore.setUseSsl(ldapServer.useSsl);
                ldapStore.setVerifySSLCertificate(ldapServer.verifySslCertificate);

                ldapStore.setLdapDirectoryType(ldapServer.ldapDirectoryType);
                ldapStore.setMappedDomainId(ldapServer.mappedDomainId || -1);
                ldapStore.setSsoEnabled(ldapServer.ssoEnabled);

                ldapStore.setBaseDn(ldapServer.baseDn);
                ldapStore.setAdditionalUserDn(ldapServer.additionalUserDn);
                ldapStore.setUserObjectClass(ldapServer.userObjectClass);
                ldapStore.setUserObjectFilter(ldapServer.userObjectFilter);
                ldapStore.setUsernameAttribute(ldapServer.usernameAttribute);
                ldapStore.setFirstNameAttribute(ldapServer.firstNameAttribute);
                ldapStore.setLastNameAttribute(ldapServer.lastNameAttribute);
                ldapStore.setEmailAttribute(ldapServer.emailAttribute);
                ldapStore.setWildcardSearch(ldapServer.wildcardSearch);              

                ldapStore.setSynchronizationEnabled(ldapServer.synchronizationEnabled);
                ldapValidator.setSynchronizationEnabled(ldapServer.synchronizationEnabled);

                ldapStore.setDefaultRoleId(ldapServer.defaultRoleId || -1);
                ldapStore.setDefaultTeamId(ldapServer.defaultTeamId);
                ldapStore.setUpdateTeamAndRoleUponLoginEnabled(ldapServer.updateTeamAndRoleUponLoginEnabled);
                ldapStore.setPeriodicalSynchronizationEnabled(ldapServer.periodicalSynchronizationEnabled);            
                
                ldapStore.setAdvancedTeamAndRoleMappingEnabled(ldapServer.advancedTeamAndRoleMappingEnabled);
                ldapValidator.setAdvancedTeamAndRoleMappingEnabled(ldapServer.advancedTeamAndRoleMappingEnabled);
                
                ldapStore.setDefaultTeamEnabled(ldapServer.defaultTeamEnabled);
                ldapValidator.setDefaultTeamEnabled(ldapServer.defaultTeamEnabled);

                ldapStore.setDefaultRoleEnabled(ldapServer.defaultRoleEnabled);

                ldapStore.setAdditionalGroupDn(ldapServer.additionalGroupDn);
                ldapStore.setGroupObjectClass(ldapServer.groupObjectClass);
                ldapStore.setGroupObjectFilter(ldapServer.groupObjectFilter);
                ldapStore.setGroupNameAttribute(ldapServer.groupNameAttribute);
                ldapStore.setGroupMembersAttribute(ldapServer.groupMembersAttribute);
                ldapStore.setUserMembershipAttribute(ldapServer.userMembershipAttribute);
                ldapStore.setGroupMembersAttributeSource(this.setGroupMembersAttributeSource(ldapServer.groupMembersAttributeSource, ldapStore));

                this.props.teamsStore.getAllTeams()
                    .then(() => {

                        this.setState({
                            edit: true
                        });
                    });

            })
            .catch((err) => {

                this.errorDialogMessage = ldapStore.getLDAPServerErrorMessage;
                this.openErrorDialog();
            })
            .finally(() => {

                this.setState({
                    getLDAPServerProgress: false
                });
            });
    }

    setGroupMembersAttributeSource(value, ldapStore){
        
        let defaultValue = ldapStore.groupMembersAttributeSourceItems[0];
        
        if(!value){
            return defaultValue;    
        }

        let valueFromItems = ldapStore.groupMembersAttributeSourceItems.find(x => x.toLowerCase() == value.toLowerCase());
        return valueFromItems ? valueFromItems : defaultValue;
    }

    cancelAddEdit = () => {

        this.currentLdapStore.resetForm();
        this.ldapValidator.resetForm();
        
        this.setState({
            edit: false
        });
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }

    render() {

        const deleteDialogMessage = 
            <div>
                {this.props.translationsStore.translate('DELETE_LDAP_SERVER_CONFIRM')
                                        .replace('{server}', this.props.server.name)}
                <br />
                {this.props.translationsStore.translate('DELETING_LDAP_SERVER_CONFIRM_WILL_DELETE_USER')}
            </div>;

        let directoryTypeName = '';

        if (this.props.server.ldapDirectoryType) {
            
            directoryTypeName = this.currentLdapStore.directoryTypes().filter((d) => {
                
                return d.id == this.props.server.ldapDirectoryType.toLowerCase();
            });

            if (directoryTypeName.length > 0) {
                
                directoryTypeName = directoryTypeName[0].text
            }
        }

        const LdapServerAdditionalDetailsTransltions = {
            directoryType: this.props.translationsStore.translate('DIRECTORY_TYPE'),
            baseDn: this.props.translationsStore.translate('BASE_DN'),
            synchronization: this.props.translationsStore.translate('SYNCHRONIZATION'),
            enabled: this.props.translationsStore.translate('ENABLED'),
            disabled: this.props.translationsStore.translate('DISABLED')
        };

        const component = this.state.edit === false ? 
                                            <div className='ldap-server-wrapper' data-cy='ldap-server-wrapper'>
                                                <div style={{display: 'flex'}}>
                                                    <LdapServerMainDetails 
                                                        name={this.props.server.name}
                                                        active={this.props.server.active}
                                                        defaultMethod={this.props.server.defaultMethod}
                                                    />
                                                    <LdapServerAdditionalDetails
                                                        directoryType={directoryTypeName}
                                                        baseDn={this.props.server.baseDn}
                                                        synchronizationEnabled={this.props.server.synchronizationEnabled}
                                                        translations={LdapServerAdditionalDetailsTransltions}
                                                    />
                                                </div>
                                                <div className='actions'>
                                                    <div>
                                                        <TrashButton 
                                                            onClick={this.openDeleteServerDialog}
                                                            dataCy='btn-delete-server'
                                                        />
                                                        <TransparentButton 
                                                            style={{
                                                                height: 25,
                                                                lineHeight: '25px',
                                                                minWidth: 0
                                                            }}
                                                            type='button'
                                                            onClick={this.openEditForm}
                                                            inProgress={this.state.getLDAPServerProgress}
                                                            text={this.props.translationsStore.translate('EDIT')}
                                                            dataCy='btn-edit-server' />
                                                    </div>
                                                </div>
                                                <DeleteDialog 
                                                    show={this.state.openDeleteDialog}
                                                    onConfirm={this.deleteServer}
                                                    deleteButtonText={this.props.translationsStore.translate('DELETE')}
                                                    cancelText={this.props.translationsStore.translate('CANCEL')}                                
                                                    closeDeleteDialog={this.closeDeleteDialog}
                                                    titleText={this.props.translationsStore.translate('DELETE_LDAP_SERVER')}
                                                    contentText={deleteDialogMessage} 
                                                    inProgress={this.currentLdapStore.deleteLDAPServerProgress}
                                                    dataCy='btn-delete-ldap-server'
                                                />
                                            </div>
                                                : <div className='ldap-edit-form-wrapper'>
                                                    <LdapEditFormsContainer 
                                                        mode={LdapEditMode.update} 
                                                        serverId={this.state.serverId}
                                                        cancelAddEdit={this.cancelAddEdit} />
                                                </div>;

        return(
            <div>
                {component}
                <ErrorDialog 
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translationsStore.translate('ERROR')}
                    contentText={this.errorDialogMessage}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/ldapServer/index.jsx